// User types that match backend API responses

export interface UserProfileResponse {
  id: string  // Changed to string to match JWT standard and User.id type
  email: string
  emailVerified?: boolean
  firstName?: string
  lastName?: string
  phone?: string
  phoneVerified?: boolean
  dateOfBirth?: string  // ISO date string (YYYY-MM-DD)
  gender?: string
  status: string
  marketingOptIn?: boolean
  transactionalOptOut?: boolean
}

export interface UserProfileUpdateRequest {
  firstName?: string
  lastName?: string
  phone?: string
  dateOfBirth?: string  // ISO date string (YYYY-MM-DD)
  gender?: string
}

export interface UpdateEmailRequest {
  newEmail: string
}

export interface UpdatePasswordRequest {
  newPassword: string
  currentPassword?: string
}

export interface UserStatisticsResponse {
  itemsWon: number
  totalBidsPlaced: number
  itemsBidOn: number
}

export const FavoriteType = {
  LISTING: 'LISTING',
  CATEGORY: 'CATEGORY',
  SELLER: 'SELLER'
} as const

export type FavoriteType = typeof FavoriteType[keyof typeof FavoriteType]

export interface FavoriteResponse {
  id: number
  userId: number
  targetType: FavoriteType
  targetId: string
  createdAt: string  // ISO timestamp
}

export interface FavoriteRequest {
  targetType: FavoriteType
  targetId: string
}

export interface FavoriteCheckResponse {
  isFavorited: boolean
}

export interface BiddingEligibilityResponse {
  eligible: boolean
  missingRequirements: string[]
  message: string
}